import {Component, Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core'
import { Subject, Subscription } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'

@Component({
  selector: 'search-bar',
  styles: [`
    :host {
      display: block;
    }
    input {
      min-width: 150px;
    }
  `],
  template: `
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
      </div>
      <input type="search" class="form-control"
        [placeholder]="placeholder"
        [ngModel]="searchString"
        (ngModelChange)="searchModelChanged.next($event)">
    </div>
    `,
})
export class SearchBar implements OnInit, OnDestroy{
  @Input() searchString = ""
  @Input() placeholder = ""
  @Output() searchStringChange = new EventEmitter<String>()

  searchModelChanged: Subject<string> = new Subject<string>()
  private modelChangedSubscription: Subscription

  ngOnInit(): void {
    this.modelChangedSubscription = this.searchModelChanged.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(newText => this.updateString(newText))
  }

  ngOnDestroy() {
    this.modelChangedSubscription.unsubscribe()
  }

  private updateString(newText: string): void {
    this.searchString = newText
    this.searchStringChange.emit(this.searchString)
  }
}
